import { CircularProgressProps, CircularProgress } from '@material-ui/core';

export type DSCircularProgressProps = CircularProgressProps;

export const DSCircularProgress = CircularProgress;
